import { createSlice } from '@reduxjs/toolkit';

export const uploadsSlice = createSlice({
  name: 'uploads',
  initialState: { records: [] },
  reducers: {
    update: (state, action) => ({ ...state, ...action.payload }),
    //status: (state, action) => ({ ...state, status: action.payload }),
  },
});

export default uploadsSlice.reducer;
